<template>
  <div class="LKMunMehCardFormRight">
    <div class="LKMunMehCardFormRight__btn-container">
      <button
        :disabled="isDisabled"
        class="LKMunMehCardFormRight__btn"
        @click="onGoToCreate"
      >
        <span
          class="LKMunMehCardFormRight__btn-text"
          v-text="btnText"
        />
        <v-icon dark size="16px" v-text="'mdi-square-edit-outline'" />
      </button>
    </div>
  </div>
</template>

<script>
import { MunMehFormStatuses } from '@/typings/api/MunMeh'
import { LK_MUN_MEH_FORM_ROUTES as ROUTES } from '@/views/LKMunMeh/Form/utils'
import { LkMunMehApi } from '@/api/resources'

export default {
  name: 'LKMunMehCardFormRight',
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    formStatus() {
      const { data, disabled } = this
      return data.form?.status
          || (disabled ? MunMehFormStatuses.not_done : MunMehFormStatuses.not_started)
    },
    btnText() {
      switch (this.formStatus) {
        case MunMehFormStatuses.not_started:
          return 'Заполнить'
        case MunMehFormStatuses.in_progress:
          return 'Редактировать'
        default:
          return 'Просмотр'
      }
    },
    isDisabled() {
      const { formStatus, disabled } = this
      return ![MunMehFormStatuses.not_started, MunMehFormStatuses.in_progress].includes(formStatus) || disabled
    },
  },
  methods: {
    async onGoToCreate() {
      if (!this.data.form) {
        const api = new LkMunMehApi()
        try {
          const { data } = await api.createForm(this.data.id)
          this.data.form = data
        } catch (e) {
          this.$notice.errors(e)
          return
        }
      }

      const location = {
        name: ROUTES.FORM,
        params: {
          munMehId: this.data.id,
          formId: this.data.form.id,
        },
      }

      await this.$router.push(location)
    },
  },
}
</script>

<style lang="scss">
$right-width: 280px;

.LKMunMehCardFormRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: $right-width;
  // text-align: center;

  &__row {
    display: flex;
    width: 100%;
  }

  &__stats {
    width: 100%;
    font-size: 12px;
    text-align: left;
  }

  &__bottom-text {
    margin-top: 8px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
    text-align: center;
  }

  &__btn {
    padding: 8px 16px;
    margin: 4px;
    font-size: 12px;
    font-weight: 600;
    color: $webflow-color-white;
    background-color: $webflow-color-blue-dark;
    border-radius: 100px;
    transition: background-color $webflow-transition;

    &:hover {
      background-color: $webflow-color-blue-dark-hover;
    }

    &[disabled] {
      background-color: $webflow-color-grey;
    }

    & + & {
      margin-left: 12px;
    }

    &-text {
      margin-right: 8px;
    }
  }

  &__chart {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__btn {
      @extend .LKMunMehCardFormRight__btn;

      & + & {
        margin: 4px;
      }
    }
  }
}
</style>
